/* Audio46 theme-generated referral lifecycle — 4 hours from click.
 * This does not manage discount codes or app-owned/affiliate attribution.
 */
(function () {
  'use strict';

  var KEY = 'a46_theme_referral_v1';
  var TTL = 4 * 60 * 60 * 1000;
  var SOURCES = ['banner', 'homepage', 'product-page', 'gift-guide', 'highlights', 'faq'];
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];
  var timer = null;
  var busy = false;
  var expiredOnThisPage = null;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  function read() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || 'null');
      return value && value.version === 1 ? value : null;
    } catch (e) { return null; }
  }

  // Install BEFORE the header-countdown collection history wrapper.
  // Prevent its cached UTM parameters from being re-added after expiry.
  function scrubUrl(url) {
    if (url == null) return url;
    var state = read() || expiredOnThisPage;
    if (!state || Date.now() < state.expiresAt) return url;
    var parsed;
    try { parsed = new URL(url, location.href); } catch (e) { return url; }
    if (parsed.origin !== location.origin) return url;
    var changed = false;
    Object.keys(state.utm || {}).forEach(function (key) {
      if (parsed.searchParams.get(key) === state.utm[key]) {
        parsed.searchParams.delete(key);
        changed = true;
      }
    });
    if (state.compatibleFrom &&
        (parsed.searchParams.get('a46_theme_ref') === 'compatible_products' ||
         parsed.searchParams.get('a46_ref') === 'compatible_products')) {
      parsed.searchParams.delete('a46_theme_ref');
      parsed.searchParams.delete('a46_ref');
      parsed.searchParams.delete('source_product');
      changed = true;
    }
    return changed ? parsed.pathname + parsed.search + parsed.hash : url;
  }

  ['replaceState', 'pushState'].forEach(function (method) {
    var original = history[method];
    history[method] = function (state, title, url) {
      return original.call(history, state, title, scrubUrl(url));
    };
  });

  function scrubCurrentUrl(state) {
    expiredOnThisPage = state;
    var clean = scrubUrl(location.href);
    if (clean !== location.href) history.replaceState(history.state, '', clean);
  }

  function write(value) {
    try { localStorage.setItem(KEY, JSON.stringify(value)); return true; }
    catch (e) { return false; }
  }

  function removeIfCurrent(id) {
    var current = read();
    if (current && current.id === id) {
      try { localStorage.removeItem(KEY); } catch (e) {}
    }
  }

  function cartRequest(path, options) {
    return fetch(root + path, Object.assign({ credentials: 'same-origin' }, options || {}))
      .then(function (response) {
        if (!response.ok) throw new Error('Cart API returned ' + response.status);
        return response.json();
      });
  }

  function updateAttributes(attributes) {
    return cartRequest('cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    });
  }

  function referralFrom(link) {
    var destination;
    try { destination = new URL(link.href, location.href); } catch (e) { return null; }
    if (destination.origin !== location.origin) return null;

    var params = destination.searchParams;
    // Countdown discount links wrap the tracking query in a redirect parameter.
    if (!params.has('utm_source') && !params.has('a46_theme_ref') && !params.has('a46_ref') && params.has('redirect')) {
      try { params = new URL(params.get('redirect'), location.origin).searchParams; }
      catch (e) { return null; }
    }

    var source = (params.get('utm_source') || '').toLowerCase();
    var isThemeUtm = SOURCES.indexOf(source) !== -1;
    var compatible = params.get('a46_theme_ref') === 'compatible_products' ||
      params.get('a46_ref') === 'compatible_products';
    if (!isThemeUtm && !compatible) return null;

    var utm = {};
    if (isThemeUtm) {
      UTM_KEYS.forEach(function (key) {
        if (params.has(key)) utm[key] = params.get(key);
      });
    }
    var from = compatible ? (params.get('source_product') || '') : '';
    if (from && !/^[a-z0-9][a-z0-9-]{0,254}$/i.test(from)) from = '';
    return { utm: utm, compatibleFrom: compatible ? from : '' };
  }

  function cleanup(state) {
    if (busy || !state || Date.now() < state.expiresAt) return;
    busy = true;
    scrubCurrentUrl(state);
    cartRequest('cart.js').then(function (cart) {
      var latest = read();
      if (!latest || latest.id !== state.id) return;
      var attributes = cart.attributes || {};
      var changes = {};
      var keys = Object.keys(state.utm || {});

      // Only touch UTM values still matching the original THEME referral.
      // A later Google/Klaviyo/affiliate attribution must not be overwritten.
      var present = keys.filter(function (key) { return attributes[key] != null && attributes[key] !== ''; });
      if (present.length && present.every(function (key) { return attributes[key] === state.utm[key]; }) &&
          (!attributes.utm_source || attributes.utm_source === state.utm.utm_source)) {
        present.forEach(function (key) { changes[key] = ''; });
      }

      if (state.compatibleFrom && attributes.a46_theme_ref === 'compatible_products' &&
          attributes.a46_theme_source_product === state.compatibleFrom) {
        changes.a46_theme_ref = '';
        changes.a46_theme_source_product = '';
      }

      // This is a public attribute; NEVER blindly clear private '__ref'.
      if (state.compatibleFrom && attributes.ref === 'compatible_products') {
        changes.ref = '';
      }

      if (!Object.keys(changes).length) return;
      return updateAttributes(changes);
    }).then(function () {
      removeIfCurrent(state.id);
    }).catch(function (error) {
      console.warn('[Audio46 referral expiry] Cleanup deferred:', error);
    }).then(function () {
      busy = false;
    });
  }

  function synchronizeReferral(state) {
    if (busy || !state || !state.pending || Date.now() >= state.expiresAt) return;
    busy = true;

    // Retire any previous theme attribution when another theme link is clicked.
    // Re-check the live cart so newer third-party attribution is not erased.
    cartRequest('cart.js').then(function (cart) {
      var latest = read();
      if (!latest || latest.id !== state.id) return;
      var existing = cart.attributes || {};
      var changes = {};
      var oldUtm = state.previousUtm || {};
      var newUtm = state.utm || {};
      if (!existing.utm_source || existing.utm_source === oldUtm.utm_source) {
        Object.keys(oldUtm).forEach(function (key) {
          if (existing[key] === oldUtm[key] && newUtm[key] !== oldUtm[key]) changes[key] = '';
        });
      }
      if (state.previousCompatibleFrom && existing.ref === 'compatible_products') {
        changes.ref = '';
      }
      changes.a46_theme_ref = state.compatibleFrom ? 'compatible_products' : '';
      changes.a46_theme_source_product = state.compatibleFrom || '';
      return updateAttributes(changes);
    }).then(function () {
      var latest = read();
      if (latest && latest.id === state.id) {
        latest.pending = false;
        write(latest);
      }
    }).catch(function (error) {
      console.warn('[Audio46 referral expiry] Cart update deferred:', error);
    }).then(function () { busy = false; });
  }

  function check() {
    if (timer) { clearTimeout(timer); timer = null; }
    var state = read();
    if (!state) return;
    var remaining = state.expiresAt - Date.now();
    if (remaining <= 0) cleanup(state);
    else {
      if (state.pending) synchronizeReferral(state);
      timer = setTimeout(check, Math.min(remaining + 100, 2147483647));
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest && target.closest('a[href]');
    if (!link) return;
    var value = referralFrom(link);
    if (!value) return;
    var at = Date.now();
    var previous = read();
    expiredOnThisPage = null;
    write({
      version: 1,
      id: String(at) + '-' + String(Math.random()).slice(2),
      expiresAt: at + TTL,
      utm: value.utm,
      compatibleFrom: value.compatibleFrom,
      previousUtm: previous ? previous.utm : {},
      previousCompatibleFrom: previous ? previous.compatibleFrom : '',
      pending: !!(value.compatibleFrom || (previous && previous.compatibleFrom) ||
        (previous && Object.keys(previous.utm || {}).length))
    });
    // The destination page will synchronize cart attributes.
  }, true);

  window.addEventListener('pageshow', check);
  window.addEventListener('focus', check);
  window.addEventListener('storage', function (event) {
    if (event.key === KEY) check();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) check();
  });
  check();
})();
